import React from "react";

export const FandomSidebar = () => {
  return (
    <div className="FandomSidebar">
      Fandom Sidebar
    </div>
  )
}
